// extracted by mini-css-extract-plugin
export default {"input":"LabeledInputWithUnit_input__7c4SY"};